<template>
  <div class='indexbox'>
    <div class="tablebox">
      <el-form ref="form" :model="info" class="formbox">
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item>
              <span class="form_tit">{{$t('lg.邮箱')}}</span>
              <el-input v-model="info.email" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item>
              <span class="form_tit">{{$t('lg.绑定时间')}}</span>
              <el-input v-model="info.create_time" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item>
              <span class="form_tit">API Account</span>
              <el-input v-model="info.api_account" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item>
              <span class="form_tit">API KEY</span>
              <el-input v-model="info.api_key" readonly></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div>
        <el-table :data="tableData" stripe border max-height="400" v-loading='loading'>
          <el-table-column :label="$t('lg.店铺名称')" prop="shop_name" align="center" show-overflow-tooltip />
          <el-table-column :label="$t('lg.平台类型')" prop="type_name" align="center" show-overflow-tooltip />
          <el-table-column :label="$t('lg.名称')" prop="shop_code" align="center" show-overflow-tooltip />
          <el-table-column :label="$t('lg.状态')" prop="shop_code" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <span style="color:#19CBBE;font-weight:550;" v-if="scope.row.status==0">{{$t('lg.未授权')}}</span>
              <span style="color:#19CBBE;font-weight:550;" v-if="scope.row.status==1">{{$t('lg.已授权')}}</span>
              <span style="color:#19CBBE;font-weight:550;" v-if="scope.row.status==2">{{$t('lg.已解绑')}}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination @current-change='pagechage' background layout="total,prev, pager, next" v-show="total>0" :current-page.sync="page" :page-size="10" :total="total" />
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        total: 0,
        page: 1,
        tableData: [],
        loading: false,
      };
    },
    props: {
      id: {
        type: [String, Number],
        default: () => { },
      },
      info: {
        type: Object,
        default: {}
      },
    },
    methods: {
      getlist() {
        this.loading = true
        this.$post({
          url: "/app/member_shop/shopList",
          data: {
            api_id: this.id,
          },
          success: (res) => {
            this.tableData = res.data.data
            this.total = res.data.total
            this.page = res.data.current_page
            setTimeout(() => {
              this.loading = false
            }, 300);
          },
          tip: () => {
            this.loading = false
          },
        })
      },
      pagechage(page) {
        this.page = page
        this.tableData = []
        this.getlist()
      },
    },
  }
</script>
<style lang='scss' scoped>
  .indexbox {
    width: 100%;
    height: 100%;
    .searchbox {
      width: 100%;
      min-width: 500px;
      padding: 10px 20px;
      background: #fff;
      border-bottom: 1px solid #babdcd;
      display: flex;
      justify-content: space-between;
      align-items: center;
      /deep/.el-form {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .el-form-item {
          margin: 0 20px 0 0 !important;
        }
      }
      /deep/.el-button {
        background-color: #d6f3e3;
        border-radius: 10px;
        color: #3b3b3b;
        border-color: #d6f3e3;
        align-self: flex-end;
      }
    }
    .tablebox {
      width: 100%;
      padding: 20px;
    }
    .formbox {
      /deep/.el-form-item {
        margin-bottom: 30px !important;
        .el-form-item__content {
          width: 100%;
          .el-button {
            width: 100%;
            height: 48px;
            background: $color;
            border-radius: 5px;
            border-color: $color;
          }
        }
      }
    }
  }
</style>